@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

@keyframes slidein {
  from {
    top: 0;
  }

  to {
    top: 182px;
  }
}

.modal {
  position: absolute;
  animation-name: slidein;
  animation-duration: 0.5s;
  z-index: 4;
  top: 182px;
  left: 50%;
  width: 550px;
  max-width: 684px;
  max-height: calc(100vh - 40px);
  padding: 28px;
  background-color: white;
  border-radius: 2px;
  transform: translate(-50%, 0);

  @include core.maxWidth(core.$mobile) {
    width: calc(100% - 32px);
    padding: 24px 16px 32px 20px;
  }

  @include core.maxWidth(core.$tablet) {
    width: calc(100% - 32px);
    padding-bottom: 32px;
  }

  &Header {
    display: flex;
    justify-content: center;
    margin-bottom: 34px;

    @include core.font(core.$xl, core.$semibold, map.get(core.$fonts, primary));

    @include core.maxWidth(core.$tablet) {
      @include core.font(core.$l, core.$semibold, map.get(core.$fonts, primary));
    }

    &Title {
      word-break: break-all;
    }

    &Icon {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 4px;
    }
  }

  &Content {
    display: flex;
    justify-content: center;
    max-height: 500px;
    overflow-y: auto;

    &Text {
      max-width: 100%;
      overflow: hidden;
      padding-left: 11px;
      padding-right: 11px;
      text-align: center;
      text-overflow: ellipsis;
    }
  }
}
